import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../../../Header";
import MenuBar from "../../../MenuBar";
import "../../../analytics/analytics.css";
import "./../webhooks.css";
import { useEffect } from "react";
import { useAuth } from "../../../../context/API_Client";
import { useState } from "react";
import ReactJson from "react-json-pretty";
import Footer from "../../../Footer";
import CustomChips from "../../../../reusableComponents/CustomChips";

const customTheme = {
  main: "line-height:1.3;color:inherit;background:#F8F8F8;overflow:auto;",
  error: "line-height:1.3;color:inherit;background:#F8F8F8;overflow:auto;",
  key: "color:#1D1C20;",
  string: "color:#1D1C20;",
  value: "color:#1D1C20;",
  boolean: "color:#1D1C20;",
  number: "color:#1D1C20;",
};

function LogsDetails() {
  const { getAllVisualizationData } = useAuth();
  const [gridData, setGridData] = useState({});
  const [paymentError, setPaymentError] = useState([]);
  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  const notificationData = queryParameters.get("notifyId");

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const fromDate = new Date(currentYear, 0, 2);
  fromDate.setHours(0, 0, 0, 0);

  const toDate = new Date();
  toDate.setHours(23, 59, 59, 999);

  const filters = { notificationId: notificationData };
  useEffect(() => {
    getAllVisualizationData(
      "entities/status_notifications",
      {
        fromDate: fromDate,
        toDate: toDate,
        attributeFilters: filters,
      },
      function (data) {
        setGridData(data?.points[0]);
      },
      function (errorMsg) {
        setPaymentError(errorMsg);
      }
    );
  }, []);

  return (
    <>
      <div
        className="content-wrapper whole-page-body"
        style={{ backgroundColor: "white" }}
      >
        <section style={{ margin: "24px" }}>
          <p className="headerH1Bold font-black-highest">
            Notification ID: {gridData?.notificationId}
          </p>
          <div
            style={{
              width: "100%",
            }}
          >
            <div
              style={{
                height: "62px",
                display: "flex",
              }}
            >
              <div
                style={{
                  height: "42px",
                  marginRight: "46px",
                }}
              >
                <p
                  style={{
                    height: "18px",
                    marginBottom: "4px",
                  }}
                  className="headerstyle"
                >
                  Event ID:
                </p>
                <p
                  style={{
                    height: "22px",
                    marginBottom: "4px",
                  }}
                  className="DetailsStyle"
                >
                  {gridData?.eventId}
                </p>
              </div>
              <div
                style={{
                  height: "42px",
                  marginRight: "46px",
                }}
              >
                <p
                  style={{
                    height: "18px",
                    marginBottom: "4px",
                  }}
                  className="headerstyle"
                >
                  Operation ID:
                </p>
                <p
                  style={{ height: "22px", marginBottom: "4px" }}
                  className="DetailsStyle"
                >
                  {gridData?.operationId}
                </p>
              </div>
              <div style={{ height: "42px", marginRight: "46px" }}>
                <p
                  style={{ height: "18px", marginBottom: "4px" }}
                  className="headerstyle"
                >
                  Order ID:
                </p>
                <p
                  style={{ height: "22px", marginBottom: "4px" }}
                  className="DetailsStyle"
                >
                  {gridData?.orderId}
                </p>
              </div>
            </div>

            <div
              style={{
                marginTop: "30px",
                height: "62px",
                // padding: "10px 0px 0px 10px",
                display: "flex",
              }}
            >
              <div
                style={{
                  height: "42px",
                  marginRight: "46px",
                }}
              >
                <p
                  style={{ height: "18px", marginBottom: "4px" }}
                  className="headerstyle"
                >
                  Date & Time:
                </p>
                <p
                  style={{ height: "22px", marginBottom: "4px" }}
                  className="DetailsStyle"
                >
                  {gridData?.timestamp}
                </p>
              </div>
              <div
                style={{
                  height: "42px",
                  marginRight: "46px",
                }}
              >
                <p
                  style={{ height: "18px", marginBottom: "4px" }}
                  className="headerstyle"
                >
                  Status:
                </p>

                <CustomChips
                  type={
                    gridData?.notificationResponseStatusCode?.toString()[0] ===
                      "2"
                      ? 1
                      : 0
                  }
                  text={gridData?.notificationResponseStatusCode}
                />
              </div>
            </div>

            <div
              style={{
                marginTop: "24px",
                height: "42px",
              }}
            >
              <p className="DetailsHeader">Detailed Report:</p>
            </div>

            <div
              style={{
                height: "auto",
              }}
            >
              <div>
                <p
                  style={{
                    height: "18px",
                    marginBottom: "4px",
                  }}
                  className="headerstyle"
                >
                  Status Notify URL
                </p>
                <p
                  style={{
                    height: "22px",
                    marginBottom: "4px",
                    marginTop: "4px",
                  }}
                  className="descriptionStyle"
                >
                  {gridData?.statusNotifyUrl}
                </p>
              </div>
              {gridData?.signature && (
                <div
                  style={{
                    marginTop: "12px",
                  }}
                >
                  <p
                    style={{
                      height: "18px",
                      marginBottom: "4px",
                    }}
                    className="headerstyle"
                  >
                    Signature
                  </p>
                  <p
                    style={{
                      height: "22px",
                      marginBottom: "4px",
                      marginTop: "4px",
                    }}
                    className="descriptionStyle"
                  >
                    {gridData?.signature}
                  </p>
                </div>
              )}
            </div>

            <div
              style={{
                marginTop: "30px",
              }}
            >
              <p className="DetailsHeader">Request Payload:</p>
            </div>
            <div
              style={{
                backgroundColor: "var(--neutral-11, F8F8F8)",
                borderRadius: "20px",
              }}
            >
              <ReactJson
                data={JSON.stringify(gridData?.notificationPayload)}
                theme={customTheme}
              />
            </div>
            <div
              style={{
                marginTop: "30px",
              }}
            >
              <p className="DetailsHeader">Response:</p>
            </div>
            <div
              style={{
                backgroundColor: "F8F8F8",
                borderRadius: "20px",
              }}
            >
              <p
                style={{
                  backgroundColor: "#F8F8F8",
                  textDecorationColor: "#1D1C20",
                  padding: "20px",
                  fontSize: "14px",
                }}
              >
                {gridData?.notificationResponse}
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default LogsDetails;
